import TransactionItemDetails from './TransactionItemDetails';

export default TransactionItemDetails;
